// extracted by mini-css-extract-plugin
export default {"loaderContent":"Loader_loaderContent__P2gov","ldsRoller":"Loader_ldsRoller__Zi8Xp","lds-roller":"Loader_lds-roller__2Hwg8"};